import { cn } from '@/lib/utils';
import { formatUnknownJson } from '@/services/bigQuerySyncPreview/formatUnknownJson';

type SchemaDriftPanelProps = {
  title: string;
  description?: string;
  drift: unknown;
  className?: string;
};

export function SchemaDriftPanel({ title, description, drift, className }: SchemaDriftPanelProps) {
  const body = formatUnknownJson(drift);

  return (
    <div
      role="alert"
      className={cn(
        'rounded-lg border-2 border-destructive/80 bg-destructive/10 p-4 text-sm shadow-sm',
        className
      )}
    >
      <h2 className="text-base font-semibold text-destructive">{title}</h2>
      {description ? <p className="mt-2 text-muted-foreground">{description}</p> : null}
      {body ? (
        <pre className="mt-3 max-h-[min(28rem,50vh)] overflow-auto rounded-md bg-background/80 p-3 font-mono text-xs leading-relaxed">
          {body}
        </pre>
      ) : (
        <p className="mt-2 text-muted-foreground">Nenhum detalhe de drift retornado.</p>
      )}
    </div>
  );
}
